import LoginForm from "src/components/LoginForm/LoginForm";
import 'src/pages/LoginPage/LoginPage.css'

export default function LoginPage() {
    return(
        <LoginForm />
    )
}